import React, { Component } from 'react'

class Media extends Component {
            
    render() {
        return (
        <div className="nlf-viewer-block nlf-viewer-image">
            <img src={this.props.data.url} alt={this.props.data.alt} />;
        </div>
        )
    }
}

export default Media


// WEBPACK FOOTER //
// ./src/Media.js